{
  "version": 1,
  "asset_id": "d449aa17-702b-471f-859a-9491f3bdc865",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d449aa17-702b-471f-859a-9491f3bdc865/clip-img_0229-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d449aa17-702b-471f-859a-9491f3bdc865/clip-img_0229-poster-sm.webp",
  "original_filename": "clip-img_0229-poster-sm.webp",
  "size": 115140,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:07:59Z"
}
